
<div id="modalBack" class="dialog-backdrop"></div>
<div id="popUp" class="dialog">
    <div id="popUpContent" class="action-required">
        <h1 class="heading">IMPORTANT INFORMATION ABOUT THE ELECTRONIC APPLICATION</h1>
        <p><strong>Electronic Application</strong></p>
        <p>Using the electronic application will send a new or edited paperless application to your client.</p>
        <p class="please-note"><strong>Please note: </strong>If you already have a signed paper application, you don't need to create an eApplication. Click <a routerLink="/ssi/home">here</a> to cancel and return to the home page, then click on Enrollment to enter your paper app.</p>
        <p>The Electronic Application will include PDF copies of the Plan Guide and other materials with the application. </p>

        <p class="content-Red" *ngIf="isShowSmartSaver"> <b>Important: SilverScript SmartSaver is not commissionable for new sales.</b>  SilverScript SmartRx is being replaced in the portfolio by SilverScript SmartSaver. Clients you previously enrolled in SilverScript SmartRx will automatically continue with SilverScript SmartSaver and you will continue to receive renewal commissions for these members.</p>
<p class="bottom-20">To continue, and send your client an application to review and sign, click the button below.</p>
        <div class="popup-button">
            <button id="continueEAP" class="button primary" (click)="onClick()">Click here to CONTINUE to the electronic application process</button>
        </div>
    </div>
</div>

